var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"entranceBackground",style:({
      backgroundColor: _vm.backgroundColor,
      backgroundImage: 'url(' + _vm.entranceBackground + ')',
    })}),_c('button',{staticClass:"btn",style:({ backgroundColor: _vm.primaryColor }),on:{"click":_vm.toLogin}},[_vm._v(" 前往预报名 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }